import { graphql } from 'react-relay';
import { queryInterop } from '@confluence/apollo-relay-interop/entry-points/query.ts';
import {
	type fetchNativeCollabConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes as Person,
	type fetchNativeCollabConfluenceUsersQuery as UsersQuery$data,
	type fetchNativeCollabConfluenceUsersQueryVariables as UsersQuery$variables,
} from './__types__/FetchNativeCollabConfluenceUsersQuery.ts';

export const fetchNativeCollabConfluenceUsers = (accountIds: string[]) => {
	return queryInterop<UsersQuery$data, UsersQuery$variables>({
		query: graphql`
			query fetchNativeCollabConfluenceUsersQuery($accountIds: [String]) {
				confluenceUsers(accountIds: $accountIds) {
					nodes {
						profilePicture {
							isDefault
							path(type: RELATIVE)
						}
						... on KnownUser {
							accountId
						}
						... on UnknownUser {
							accountId
						}
						displayName
					}
				}
			}
		`,
		variables: {
			accountIds,
		},
	}).then(({ data }) => {
		return (
			data?.confluenceUsers?.nodes
				?.filter((user): user is Person => (user as any)?.accountId)
				.map((user) => ({
					avatar: user.profilePicture?.path ?? '',
					email: '',
					isGuest: undefined,
					name: user.displayName ?? '',
					userId: (user as any).accountId,
				})) ?? []
		);
	});
};
